// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { SshKeyData, UProfileIdentifier } from "./TypeDefinitions.ts"

export interface SshKeys {
  addSshKey(profile: UProfileIdentifier, key: string, comment: string): Promise<void>

  deleteSshKey(profile: UProfileIdentifier, fingerprint: string): Promise<void>

  listSshKeys(profile: UProfileIdentifier): Promise<SshKeyData[]>
}

export class SshKeysClient implements SshKeys {
  constructor(private service: ApiService) {}

  async addSshKey(profile: UProfileIdentifier, key: string, comment: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("SshKeys/addSshKey", {
      profile: profile,
      key: key,
      comment: comment,
    }))
  }

  async deleteSshKey(profile: UProfileIdentifier, fingerprint: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("SshKeys/deleteSshKey", {
      profile: profile,
      fingerprint: fingerprint,
    }))
  }

  async listSshKeys(profile: UProfileIdentifier): Promise<SshKeyData[]> {
    return getResult(await this.service.rpc<SshKeyData[], never>("SshKeys/listSshKeys", {
      profile: profile,
    }))
  }

}

